export const coreComponentTags = [
  'wa-badge',
  'wa-breadcrumb',
  'wa-breadcrumb-item',
  'wa-button',
  'wa-button-group',
  'wa-callout',
  'wa-card',
  'wa-copy-button',
  'wa-divider',
  'wa-input',
  'wa-spinner',
] as const;
